import t from "./index.ce.vue2.js";
import o from "./index.ce.vue3.js";
import m from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ m(t, [["styles", [o]]]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/manage-mentList/index.ce.vue.js
// module id = 1265
// module chunks = 41